import 'bootstrap/dist/css/bootstrap.css'
import './App.css';
import React from "react";

import Home from './components/Home'
import Navigation from './components/Navigation';


const App = () =>
(
  <div className="bg-light text-dark">
    <Navigation />
    <Home />
  </div>
);


export default App;
